<template>
  <div class="daily-report-layout-list">
    <template v-if="listLoading">
      <div class="not-searched">
        <label>
          {{ i18n.global.t('pages.common.list.reading') }}
        </label>
      </div>
    </template>
    <ResizableList
      scrollAreaSelector=".v-table__wrapper"
    >
      <div class="table-scrollbar">
        <v-table>
          <thead>
            <tr>
              <th class="col-md-1" >
                {{ i18n.global.t('pages.dailyReportLayout.list.id') }}
              </th>
              <th class="col-md-3" >
                {{ i18n.global.t('pages.dailyReportLayout.name') }}
              </th>
              <th class="col-md-1" >
                {{ i18n.global.t('pages.dailyReportLayout.list.note') }}
              </th>
              <th class="col-md-2" >
                {{ i18n.global.t('pages.dailyReportLayout.list.updateAt') }}
              </th>
              <th class="col-md-3" >
                {{ i18n.global.t('pages.dailyReportLayout.list.updateBy') }}
              </th>
              <th class="col-md-1" >
                {{ i18n.global.t('pages.dailyReportLayout.list.edit') }}
              </th>
              <th class="col-md-1" >
                {{ i18n.global.t('pages.dailyReportLayout.list.delete') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-if="items?.length != 0">
            <tr
              v-for="item in items"
              :key="'item_id_' + item?.id"
            >
              <td> {{item.id}}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.is_note }}</td>
              <td>{{ item.updated_at?.split(" ")[0] }}</td>
              <td>
                <DisplayFullnameFromUpdatedBy
                  :updatedBy="item.updated_by"
                />
              </td>
              <td>
                <UpdateModal v-if="props.authorityList['octlink.daily_report_layout.update']"
                  :item="item"
                  @updateItem="updateItem"
                  :showFlash="showFlash"
                  icon="edit_note"
                  :label="i18n.global.t('pages.dailyReportLayout.list.update')"
                />
              </td>
              <td>
                <DeleteModal v-if="props.authorityList['octlink.daily_report_layout.delete']"
                  :item="item"
                  @change="updateItem"
                  :showFlash="showFlash"
                />
              </td>
            </tr>
            </template>
            <template v-else-if="!listLoading">
              <tr>
                <td colspan="7">
                  {{ i18n.global.t('pages.common.list.noData') }}
                </td>
              </tr>
            </template>
          </tbody>
        </v-table>
      </div>
    </ResizableList>
  </div>
</template>

<script setup>
  import UpdateModal from "@/components/DailyReportLayoutParts/UpdateModal"
  import ResizableList from '@/components/ResizableList.vue';
  import DeleteModal from "@/components/DailyReportLayoutParts/DeleteModal"
  import DisplayFullnameFromUpdatedBy from '@/components/Common/DisplayFullnameFromUpdatedBy.vue';
  import { ref, defineProps, defineEmits, toRefs, watch } from 'vue'
  import i18n from '@/lang/i18n';

  const props = defineProps({
    items: [],
    listLoading: {
      type: Boolean,
      default: false
    },
    showFlash: {
      type: Function
    },
    authorityList: [],
  });

  const {items, listLoading, showFlash} = toRefs(props);
  const form = ref({});

  const emit = defineEmits(['changeItem'])
  const updateItem = (item) => {
    emit('changeItem');
  };
</script>

<style>
.daily-report-layout-list .v-table__wrapper{
  height: var(--resizable-height, var(--list-default-height));
  overflow: auto;
}
</style>
<style scoped>
.daily-report-layout-list {
  position: relative;
}
.daily-report-layout-list table th {
  background-color: #f8f9fa;
  position: sticky;
  top: 0;
  min-width: 7em;
}
.checkbox-in-grid {
  padding: 1vm;
  height: inherit !important;
  display: inline-grid !important;
}
</style>
